import { FC } from 'react'
import { Row, Col, Text, Breadcrumb, Content, Image } from '@/client/components'
import * as S from './styles'
import { FeaturedProps } from '../types'

export const Featured: FC<FeaturedProps> = ({ breadcrumb, title, subtitle, description, featured_img }) => (
  <S.Featured>
    <Row>
      <Col>
        <Breadcrumb pages={breadcrumb} />
      </Col>
    </Row>
    <Row>
      <Col>
        <S.MainFeatured>
          <S.LeftFeatured>
            <Text as='h2' color='primary' family='heading'>
              {subtitle}
            </Text>
            <Text as='h1' size='xxlg' family='heading' weight='bold' margin='0 0 2.5rem' itemProp='name'>
              {title}
            </Text>

            <Content content={description} />
          </S.LeftFeatured>

          <S.Product>
            <S.ProductImg>
              <S.OutlinedSquare />
              <Image imageData={featured_img} hasBreakpoint priority />
            </S.ProductImg>
          </S.Product>
        </S.MainFeatured>
      </Col>
    </Row>
  </S.Featured>
)
